import { createContext, useEffect, useState } from "react";

const AuthContext = createContext(null);
export const AuthProvider = ({children})=>{
    const loggedUser = localStorage.getItem('usrdev');
    // console.log('There is a user', loggedUser);
    const prsUserData = JSON.parse(loggedUser);
 
    const [authState, setAuthState] = useState({
        avatar: prsUserData?.avatar ||'',
        accessToken: prsUserData?.token ||'',
        email: prsUserData?.email ||'',
        id: prsUserData?.id ||'',
        refreshToken: prsUserData?.refreshToken ||'',
        user: prsUserData?.username||'',
    });

    return(
        <AuthContext.Provider value={{authState, setAuthState }}>
            {children}
        </AuthContext.Provider>
    ) 
}
export default AuthContext;